import authService from '../components/api-authorization/AuthorizeService'
import CurrentEventViewModel from '../models/events/currentEventViewModel';
import CreateEventCommand from '../models/events/createEventCommand';
import EventViewModel from '../models/events/GetEvents/EventViewModel';
import EventDetailsViewModel from '../models/events/GetEventDetails/EventDetailsViewModel';

export default class EventController {
    async GetCurrentEvent() : Promise<CurrentEventViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('event/GetCurrentEvent', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }

    async GetEvents() : Promise<EventViewModel[] | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('event/GetEvents', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }
    
    async GetEventDetails(eventId: string) : Promise<EventDetailsViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('event/GetEventDetails?eventId=' + eventId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }
    async CreateEvent(event: CreateEventCommand) : Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('event/CreateEvent', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(event)
        });
        if (response.status == 201) {
            return true;
        }
        return false;
    } 

    async EndEvent() : Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('event/EndEvent', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
        });
        if (response.status == 200) {
            return true;
        }
        return false;
    }
}